import React, { Component } from "react";
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import { confirmAlert } from 'react-confirm-alert';
import { NotificationManager } from 'react-notifications';
import Alert from "@mui/material/Alert";

// Services
import providersService from '@services/providers';
import nifService from '@services/nif';

// Components
import Menu from '@components/Menu'

/* Import Components */
import Input from "@components/Input";
import TextArea from "@components/TextArea";
import Button from "@components/Button";
import { validateNIF } from '@utils/nif';

class Form extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

  constructor(props) {
    super(props);

    const { match: { params }, type } = this.props;

    this.state = {
        form: {
            next: '',
            previous: '',
            loading: {
                save: false,
            },
        },
        loaded: false,
        name: '',
        nif: '',
        email: '',
        phone: '',
        address: '',
        idapollo: '',
        idempresa: this.props.cookies.get('member_idempresa'),
        idprovider: type === 'edit' && params.idprovider,
        edit: type === 'edit',
        data: [],
        dataChanged: -1,
        dataAvailable: false,
        nifError: '',
        isSubmitting: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFormCancel = this.handleFormCancel.bind(this);
    this.loadFunction = this.loadFunction.bind(this);
    this.deleteFunction = this.deleteFunction.bind(this);
    this.handleFormPrevious = this.handleFormPrevious.bind(this);
    this.handleFormNext = this.handleFormNext.bind(this);
    this.handleNifKeyPress = this.handleNifKeyPress.bind(this);
  }

  async loadFunction() {
    if (!this.state.loaded) {
        if (this.props.type === 'edit') {
            try {
                const [providers, form] = await Promise.all([
                    providersService.getById(this.props.cookies.get('member_idempresa'), this.state.idprovider),
                    providersService.getForm(this.props.cookies.get('member_idempresa'), this.state.idprovider)
                ]);

                const provider = providers && providers.length > 0 ? providers[0] : {};
                this.setState({ 
                    ...provider, 
                    idapollo: provider.idapollo >= 0 ? provider.idapollo : null, 
                    loaded: true, 
                    dataAvailable: true,
                    form: {
                        ...this.state.form,
                        ...form,
                    }
                });
            } catch (error) {
                console.error(error);
                this.setState({ loaded: true });
            }
        } else {
            this.setState({ loaded: true });
        }
    }
  }

  async fetchVies(value) {
    if (!validateNIF(value)) {
      this.setState({
        nifError: (
          <Alert severity="error">
            <p>NIF inválido!</p>
          </Alert>
        ),
      })
      return;
    }

    const response = await nifService.get(value);

    if (!response || !response.isValid) {
      this.setState({
        nifError: (
          <Alert severity="warning">
            <p>NIF não reconhecido!</p>
            <button
              type="button"
              onClick={() => this.setState({ dataAvailable: true })}
              style={{
                background: 'none',
                border: 'none',
                color: '#007bff',
                textDecoration: 'underline',
                cursor: 'pointer',
                padding: 0,
                fontSize: 'inherit'
              }}
            >
              Preenchimento manual
            </button>
          </Alert>
        ),
      })
      return;
    }

    const postalCodeLocalityMatch = response.address.match(/(\d{4}-\d{3})\s+(.+)/);
    const postalCode = postalCodeLocalityMatch ? postalCodeLocalityMatch[1] : null;
    const locality = postalCodeLocalityMatch ? postalCodeLocalityMatch[2].trim() : null;

    // Extract address (first line before the first newline)
    const [addressLine] = response.address.split('\n');
    const address = addressLine.trim();

    this.setState({
      name: response.name,
      address: address+"\n"+postalCode+" "+locality,
      dataAvailable: true,
    })
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;
    
    if (name === 'nif') {
        if (!this.dataAvailable && value.length === 9) {
          this.fetchVies(value);
        } else if (value.length > 9) {
          this.setState({ [name]: value.substring(0, 9) });
          return;
        }
    }

    this.setState({
        [name]: value,
    });
    
    if (callback) {
        callback();
    }
  }

  handleNifKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const { value } = e.target;
      if (value && value.length === 9) {
        this.fetchVies(value);
      }
    }
  }

  handleFormSubmit(e) {
    const { history } = this.props;
    e.preventDefault();
    
    this.setState({ form: {
        ...this.state.form,
        loading: {
            ...this.state.loading,
            save: true,
        },
    }, loaded: true });

    this.setState({ isSubmitting: true });

    providersService.set({
        name: this.state.name,
        nif: this.state.nif,
        email: this.state.email,
        phone: this.state.phone,
        address: this.state.address,
        idempresa: this.state.idempresa,
        idprovider: this.state.idprovider,
        idapollo: this.state.idapollo,
    })
    .then(response => {
        NotificationManager.success('Guardado com sucesso', 'Fornecedor');
        if (!this.state.idprovider) {
            history.push('/providers');
        }
    })
    .finally(() => {
        this.setState({ form: {
            ...this.state.form,
            loading: {
                ...this.state.loading,
                save: false,
            },
        }, loaded: true, isSubmitting: false });
    })
    .catch(error => {
        console.error(error);
    });
  }

  async deleteFunction() {
    this.setState({ form: {
        ...this.state.form,
        loading: {
            ...this.state.loading,
            delete: true,
        },
    }});
    confirmAlert({
        title: 'Confirmação',
        message: `Tem a certeza que deseja apagar o fornecedor ${this.state.name}?`,
        buttons: [
            {
                label: 'Sim',
                onClick: () => {
                    providersService.unset(this.props.cookies.get('member_idempresa'), this.state.idprovider)
                    .then(response => {
                        if (response !== 'NOK') {
                            this.handleFormCancel();
                        }
                    })
                    .finally(() => {
                        this.setState({ form: {
                            ...this.state.form,
                            loading: {
                                ...this.state.loading,
                                delete: false,
                            },
                        }});
                    })
                    .catch(error => {
                        console.error(error);
                    });
                }
            },
            {
                label: 'Não',
                onClick: () => {
                    this.setState({ form: {
                        ...this.state.form,
                        loading: {
                            ...this.state.loading,
                            delete: false,
                        },
                    }});
                }
            }
        ]
    });
}

  handleFormCancel() {
    const { history } = this.props;
    history.push('/providers');
  }

  handleFormPrevious() {
    window.location.href = `/providers/${this.state.form.previous}`;
  }

  handleFormNext() {
    window.location.href = `/providers/${this.state.form.next}`;
  }

  render() {
    const { location, history } = this.props;
    const {
        edit,
        loaded,
        name,
        nif,
        email,
        phone,
        address,
        idapollo,
        form,
        dataAvailable,
        nifError,
        isSubmitting,
    } = this.state;
    const cookies = new URLSearchParams(location.search);

    return (
        <div>
            <Menu loadFunction={ this.loadFunction } location={ location } history={ history } newCookies={ cookies } />
            <div className="fullContainer" style={{ maxWidth: '100%' }}>
                <div className="col-xs-12">
                    <ol
                        style={{
                            textAlign: 'left',
                            'marginTop': '75px',
                        }}
                        className="breadcrumb"
                    >
                        <li><a href="http://eposgestofinal.com/index.php">Portal</a></li>
                        <li><a href="/providers">Fornecedores</a></li>
                        <li className="active">
                            {edit ? (<span>{name}</span>) : (<span>Novo Fornecedor</span>)}
                        </li>
                    </ol>
                </div>
            </div>
            {loaded && (
            <div
                className="fullContainer" style={{ maxWidth: '100%' }}
            >
                <div
                    className="col-sm-12"
                    style={{ textAlign: 'center' }}
                >
                    <div className="panel panel-default">
                        <div
                            className="panel-heading"
                            style={{
                                fontWeight: 'bold',
                                fontSize: '15pt',
                            }}
                        >
                            <table style={{
                                width: '100%'
                            }}>
                                <tr>

                                    <td style={{ width: '200px', textAlign: 'left' }}>
                                        {form.previous ? (
                                            <Button
                                                action={this.handleFormPrevious}
                                                type={"secondary"}
                                                title={"< Anterior"}
                                                style={buttonStyle}
                                            />
                                        ) : null}
                                    </td>
                                    <td>Detalhes</td>
                                    <td style={{ width: '200px', textAlign: 'right' }}>
                                        {form.next ? (
                                            <Button
                                                action={this.handleFormNext}
                                                type={"secondary"}
                                                title={"Seguinte >"}
                                                style={buttonStyle}
                                            />
                                        ) : null}
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <form onSubmit={this.handleFormSubmit} className="customer-form">
                            <div style={{
                            display: 'grid',
                            gap: '24px'
                            }}>
                            {/* NIF Card */}
                            <div style={{
                                backgroundColor: 'white',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                            }}>
                                <div style={{
                                padding: '16px 24px',
                                borderBottom: '1px solid #e2e8f0',
                                backgroundColor: '#f8fafc'
                                }}>
                                <h2 style={{
                                    fontSize: '1.25rem',
                                    fontWeight: '600',
                                    color: '#1e293b',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                    <circle cx="12" cy="7" r="4"/>
                                    </svg>
                                    Informações Fiscal
                                </h2>
                                </div>
                                <div style={{
                                    padding: '24px',
                                    display: 'flex',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                    gap: '20px',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                }}>
                                <Input
                                    title="NIF"
                                    autocomplete="off"
                                    inputType="number"
                                    name="nif"
                                    value={nif}
                                    handleChange={this.handleChange}
                                    onKeyPress={this.handleNifKeyPress}
                                    required
                                    className="nif-no-arrows"
                                    icon={
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                        <rect x="3" y="4" width="18" height="16" rx="2"/>
                                        <path d="M7 8h10M7 12h10M7 16h10"/>
                                    </svg>
                                    }
                                />
                                </div>
                                <div style={{
                                    padding: '24px',
                                    display: nifError && !dataAvailable ? 'grid' : 'none',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                    gap: '20px'
                                }}>
                                {nifError && !dataAvailable && nifError}
                                </div>
                            </div>
                
                            {dataAvailable && (
                                <>
                                {/* Personal Information Card */}
                                <div style={{
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                                }}>
                                    <div style={{
                                    padding: '16px 24px',
                                    borderBottom: '1px solid #e2e8f0',
                                    backgroundColor: '#f8fafc'
                                    }}>
                                    <h2 style={{
                                        fontSize: '1.25rem',
                                        fontWeight: '600',
                                        color: '#1e293b',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                        <circle cx="12" cy="7" r="4"/>
                                        </svg>
                                        Informações Pessoais
                                    </h2>
                                    </div>
                                    <div style={{
                                    padding: '24px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                    gap: '20px'
                                    }}>
                                    <Input
                                        title="Nome Principal"
                                        inputType="text"
                                        name="name"
                                        value={name}
                                        handleChange={this.handleChange}
                                        required
                                        icon={
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                            <circle cx="12" cy="7" r="4"/>
                                        </svg>
                                        }
                                    />
                                    <Input
                                        title="E-Mail"
                                        inputType="email"
                                        name="email"
                                        value={email}
                                        handleChange={this.handleChange}
                                        icon={
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                            <polyline points="22,6 12,13 2,6"/>
                                        </svg>
                                        }
                                    />
                                    </div>
                                </div>
                
                                {/* Contact Information Card */}
                                <div style={{
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                                }}>
                                    <div style={{
                                    padding: '16px 24px',
                                    borderBottom: '1px solid #e2e8f0',
                                    backgroundColor: '#f8fafc'
                                    }}>
                                    <h2 style={{
                                        fontSize: '1.25rem',
                                        fontWeight: '600',
                                        color: '#1e293b',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                                        </svg>
                                        Contatos
                                    </h2>
                                    </div>
                                    <div style={{
                                    padding: '24px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                    gap: '20px'
                                    }}>
                                    <Input
                                        title="Telefone Principal"
                                        inputType="tel"
                                        name="phone"
                                        value={phone}
                                        handleChange={this.handleChange}
                                        icon={
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                                        </svg>
                                        }
                                    />
                                    </div>
                                </div>
                
                                {/* Address and Financial Card */}
                                <div style={{
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                                }}>
                                    <div style={{
                                    padding: '16px 24px',
                                    borderBottom: '1px solid #e2e8f0',
                                    backgroundColor: '#f8fafc'
                                    }}>
                                    <h2 style={{
                                        fontSize: '1.25rem',
                                        fontWeight: '600',
                                        color: '#1e293b',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                                        <polyline points="9 22 9 12 15 12 15 22"/>
                                        </svg>
                                        Endereço
                                    </h2>
                                    </div>
                                    <div style={{
                                    padding: '24px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                    gap: '20px'
                                    }}>
                                    <TextArea
                                    title={"Morada"}
                                    rows={5}
                                    value={address}
                                    name={"address"}
                                    handleChange={this.handleChange}
                                    />
                                    </div>
                                </div>

                                {/* Extra */}
                                <div style={{
                                    backgroundColor: 'white',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                                }}>
                                    <div style={{
                                    padding: '16px 24px',
                                    borderBottom: '1px solid #e2e8f0',
                                    backgroundColor: '#f8fafc'
                                    }}>
                                    <h2 style={{
                                        fontSize: '1.25rem',
                                        fontWeight: '600',
                                        color: '#1e293b',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                                        <polyline points="9 22 9 12 15 12 15 22"/>
                                        </svg>
                                        Informação Técnica
                                    </h2>
                                    </div>
                                    <div style={{
                                    padding: '24px',
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                                    gap: '20px'
                                    }}>
                                    <Input
                                        title="ID Apollo"
                                        inputType="number"
                                        name="idapollo"
                                        value={idapollo}
                                        handleChange={this.handleChange}
                                        icon={
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                                            <polyline points="9 22 9 12 15 12 15 22"/>
                                        </svg>
                                        }
                                    />
                                    </div>
                                </div>
                                </>
                            )}
                            </div>
                
                            {dataAvailable && (
                            <div style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: '16px',
                                marginTop: '32px',
                                padding: '24px',
                                backgroundColor: 'white',
                                borderRadius: '12px',
                                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
                            }}>
                                {edit && (
                                    <button
                                    type="button"
                                    onClick={this.deleteFunction}
                                    style={{
                                        padding: '10px 20px',
                                        borderRadius: '8px',
                                        border: '1px solid #e2e8f0',
                                        backgroundColor: '#fd9999',
                                        color: '#ffffff',
                                        fontSize: '0.875rem',
                                        fontWeight: '500',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s'
                                    }}
                                    >
                                    Apagar
                                    </button>
                                )}
                                <button
                                type="button"
                                onClick={() => window.location.href = "/providers"}
                                style={{
                                    padding: '10px 20px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0',
                                    backgroundColor: 'white',
                                    color: '#64748b',
                                    fontSize: '0.875rem',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s'
                                }}
                                >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M19 12H5M12 19l-7-7 7-7"/>
                                </svg>
                                Voltar
                                </button>
                                <button
                                type="submit"
                                disabled={isSubmitting}
                                style={{
                                    padding: '10px 20px',
                                    borderRadius: '8px',
                                    border: 'none',
                                    backgroundColor: '#3b82f6',
                                    color: 'white',
                                    fontSize: '0.875rem',
                                    fontWeight: '500',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                    transition: 'all 0.2s',
                                    opacity: isSubmitting ? 0.7 : 1
                                }}
                                >
                                {isSubmitting ? (
                                    <>
                                    <svg className="animate-spin" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="10" strokeDasharray="32" strokeDashoffset="32"/>
                                    </svg>
                                    Processando...
                                    </>
                                ) : (
                                    <>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M5 13l4 4L19 7"/>
                                    </svg>
                                    {edit ? "Guardar Alterações" : "Criar Fornecedor"}
                                    </>
                                )}
                                </button>
                            </div>
                            )}
                        </form>
                    </div>
                </div>
            </div>
            )}
        </div>
    );
  }
}

const buttonStyle = {
  margin: "10px 10px 10px 10px"
};

export default withCookies(Form);
